import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-design-system-utils',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map